import { Action } from "@ngrx/store";
import { compact } from "lodash-es";

import { ActionWithPayload } from "../model";

const ACTION_PREFIX = "[Batch Actions]";
export const BATCH_ACTION_TYPE = {
	batchActions: `${ACTION_PREFIX}`,
};

export function batchActions(
	...payload: (ActionWithPayload | Action | undefined)[]
): ActionWithPayload<(ActionWithPayload | Action)[]> {
	return {
		type: BATCH_ACTION_TYPE.batchActions,
		payload: compact(payload),
	};
}

export function enableBatching(reducer: any) {
	return function batchingReducer(state: any, action: ActionWithPayload) {
		if (action.type === BATCH_ACTION_TYPE.batchActions) {
			return action.payload.reduce(batchingReducer, state);
		}
		return reducer(state, action);
	};
}
